import React, { useContext, useState } from "react";
import Cookies from "universal-cookie";
import "../../styles/dashboard.css";
import { Link } from "react-router-dom";
import AuthContext from "../../logincomponent/subcomponent/context/AuthProvider";
import { useEffect, useRef } from "react";
import Avatar from "@mui/material/Avatar";
import Stack from "@mui/material/Stack";
import { GlobalContext } from "../../../context/GlobalContext";

const ProfileDropdown = () => {
  const { state } = useContext(GlobalContext);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const { setAuth } = useContext(AuthContext);
  const cookies = new Cookies();

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  // Remove address component from local storage, if present
  const removeAddressComponentsFromLocalstorage = () => {
    const keysToRemove = [
      "homeComponentsMazo",
      "companyComponentsMazo",
      "secondOwnerHomeComponentsMazo",
      "residentialComponentsMazo",
      "mailingComponentsMazo",
      "employerComponentsMazo",
      "coApplicantEmployerComponentsMazo",
      "coApplicantResidentialComponentsMazo",
    ];

    keysToRemove.forEach((key) => {
      if (localStorage.getItem(key) !== null) {
        localStorage.removeItem(key);
      }
    });
  };

  const logout = () => {
    setAuth({});
    window.localStorage.setItem("isLoggedIn", "false");
    cookies.remove("access");
    cookies.remove("refresh");
    removeAddressComponentsFromLocalstorage();
    window.location.replace("/login");
  };

  // Close the dropdown when clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="profile-dropdown" ref={dropdownRef}>
      <div className="profile-button" onClick={toggleDropdown}>
        <Stack direction="row" spacing={2}>
          <Avatar sx={{ bgcolor: "#0094FF" }}>
            {state.user?.firstName && state?.user?.lastName
              ? `${state.user?.firstName
                  .charAt(0)
                  .toUpperCase()}${state?.user?.lastName
                  .charAt(0)
                  .toUpperCase()}`
              : `${state.user.username.charAt(0)}`}
          </Avatar>
        </Stack>
      </div>
      {isOpen && (
        <div className="dropdown-content">
          <Link to="/profile">Profile</Link>
          <Link to="" onClick={logout}>
            Logout
          </Link>
        </div>
      )}
    </div>
  );
};

export default ProfileDropdown;
